<div class="container">
  <app-template [title]="'Result Printing'" *ngIf="finalize">
    <div class="no">
      <img
        style="width: 150px; height: 150px; margin-left: 20px"
        src="assets/img/error2.png"
        alt=""
      />
      <button
        type="button"
        (click)="back()"
        class="button"
        mat-raised-button
        color="primary"
        style="width: 120px; margin-left: 20px; margin-bottom: 30px"
      >
        Select Result
      </button>
      Sorry something went wrong with the result
    </div>
  </app-template>
  <div [ngSwitch]="mode" *ngIf="!finalize">
    <div *ngSwitchCase="'form'">
      <app-template [title]="'Result Printing'" style="padding-bottom: 400px">
        <!-- <div class="info">
                <div class="single">
                    <div>
                      <p>Reg No. : <b>{{record.bill_no}}</b></p>
                      <p>Sub Dept. : <b>{{record.sub_department_name}}</b></p>
                      <p>Service Name : <b>{{record.service_name}}</b></p>
                      <p>Dept. : <b>{{record.department_name}}</b></p>
                    </div>
                  </div>
                  <button [disabled]="stateForm.invalid" (click)="onSubmit(e)"  mat-raised-button color="primary">
                    {{ isSaveLoading? "Adding": "Add"}}
                </button>
            </div> -->
        <div class="data" style="padding-bottom: 400px">
          <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
            <mat-spinner></mat-spinner>
          </div>
          <table *ngIf="!isLoading" style="width: 100%">
            <tr class="back">
              <th>Bill Number</th>
              <th>Lab ID</th>
              <th>Finalised</th>
              <th>Service Name</th>
              <th>Department</th>
              <th>
                <button
                  mat-raised-button
                  color="basic"
                  (click)="pushAllOnline()"
                  [disabled]="Paymentstatus"
                >
                  Push All
                </button>
                <span style="font-size: 13px; font-weight: 400">
                  <mat-checkbox
                    style="margin: 20px"
                    color="danger"
                    [(ngModel)]="NotifyDefaultRefDoctor"
                    >Notify Dr.</mat-checkbox
                  >
                </span>
              </th>
              <th>
                <button
                  mat-raised-button
                  color="primary"
                  (click)="optionsForMerge()"
                  [disabled]="Paymentstatus"
                >
                  Merge Print
                </button>
              </th>
            </tr>
            <tr class="td" *ngFor="let item of data" style="cursor: pointer">
              <td>{{ item.bill_no }}</td>
              <td>{{ item.bill_id }}</td>
              <td *ngIf="item.is_finalized == 'N'">{{ item.is_finalized }}</td>
              <td *ngIf="item.is_finalized == 'Y'">
                <img
                  style="width: 30px; height: 30px"
                  src="assets/icons/done.gif"
                  alt=""
                />
              </td>
              <td *ngIf="item.is_finalized == 'N'">{{ item.service_name }}</td>
              <td
                style="background-color: green; color: white"
                *ngIf="item.is_finalized == 'Y'"
              >
                {{ item.service_name }}
              </td>
              <td>{{ item.department_name }}</td>
              <td>
                <div class="dropdown">
                  <button class="dropbtn" mat-raised-button>Actions</button>
                  <div class="dropdown-content">
                    <a class="dropdown-item" (click)="checkStatus2(item)"
                      >Select</a
                    >
                    <a class="dropdown-item" (click)="checkStatus(item)"
                      >Push online</a
                    >
                  </div>
                </div>
              </td>
              <td></td>
            </tr>
          </table>
        </div>
      </app-template>
    </div>
    <div class="wizwig" *ngSwitchCase="'merge'">
      <app-template
        [title]="'Print Merge Result'"
        style="z-index: -3; padding-bottom: 500px"
      >
        <button
          (click)="back()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>

        <div class="search" style="padding-top: 20px">
          <span class="input">
            <mat-form-field>
              <mat-label>Push Online</mat-label>
              <mat-select
                [(ngModel)]="is_push_online"
                (selectionChange)="selectPushOnline($event)"
                matNativeControl
              >
                <mat-option value="0"> No </mat-option>
                <mat-option value="1"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Machine Data</mat-label>
              <mat-select
                [(ngModel)]="is_machine_data"
                (selectionChange)="selectMachineData($event)"
                matNativeControl
              >
                <mat-option value="0"> No </mat-option>
                <mat-option value="1"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Letterhead</mat-label>
              <mat-select
                [(ngModel)]="is_letterhead"
                (selectionChange)="selectLetterHead($event)"
                matNativeControl
              >
                <mat-option value="0"> No </mat-option>
                <mat-option value="1"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>PDF</mat-label>
              <mat-select
                [(ngModel)]="is_pdf"
                (selectionChange)="selectPdf($event)"
                matNativeControl
              >
                <mat-option value="0"> No </mat-option>
                <mat-option value="1"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
        <button
          (click)="mergePrintResults()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Merge Print
        </button>

        <div *ngIf="tempMergeLoad">
          <div>
            <!-- <button
              (click)="printMerge()"
              class="create"
              mat-raised-button
              color="primary"
            >
              Print
            </button> -->
            <button
              (click)="printEditorContent()"
              class="create"
              mat-raised-button
              color="primary"
            >
              Print
            </button>
          </div>

          <angular-editor
            [config]="editorConfig"
            [placeholder]="'Enter text here...'"
            [(ngModel)]="content"
          ></angular-editor>

          <!-- <div
            class="result"
            id="print-merge-section"
            style="width: 900px; margin: auto; position: relative"
          >
            <div
              class="detail"
              style="
                margin-top: 0px;
                z-index: 2;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-bottom: 20px;
                padding: 0 20px;
              "
            >
              <div
                class="return"
                style="width: 800px; margin-bottom: 20px; z-index: 2"
                #merge
              ></div>
            </div>
          </div> -->
        </div>
      </app-template>
    </div>

    <div class="wizwig" *ngSwitchCase="'wiz'">
      <app-template
        [title]="'Print Result'"
        style="z-index: -3; padding-bottom: 500px"
      >
        <!-- <button
          mat-raised-button
          [disabled]="!isPaid"
          color="primary"
          (click)="print()"
        >
          Print
        </button> -->
        <button
          mat-raised-button
          color="primary"
          [disabled]="Paymentstatus"
          (click)="print()"
        >
          Print
        </button>

        <button
          *ngIf="!statusLoad"
          (click)="status()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Status
        </button>
        <button
          *ngIf="statusLoad"
          class="create"
          mat-raised-button
          color="primary"
        >
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </button>

        <button
          (click)="back()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>
        <span>
          <label>Show barcode</label>
          <input
            [(ngModel)]="isChecked"
            (change)="checkValue(isChecked ? 'true' : 'false')"
            style="margin: 0 20px; cursor: pointer"
            type="checkbox"
          />
        </span>
        <div class="space"></div>
        <div class="form">
          <!-- <div *ngIf="tempLoad" style="margin-top: 50px;" class="spinner">
                <mat-spinner></mat-spinner>
              </div> -->
          <div
            *ngIf="!tempLoad"
            class="result"
            id="print-section"
            style="width: 900px; margin: auto; position: relative"
          >
            <div
              class="detail"
              style="
                margin-top: 0px;
                z-index: 2;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-bottom: 20px;
                padding: 0 20px;
              "
            >
              <div class="main" style="z-index: 2">
                <div class="head">
                  <b>Patient Name :</b> {{ templates?.data?.patient_name }}
                </div>
                <div class="head">
                  <b>Gender :</b> {{ templates?.data?.sex }}
                </div>
                <!-- <div class="head">
                  <b>Age :</b> {{ patient?.date_of_birth | date }} ({{
                    patient?.age
                  }}
                  years)
                </div> -->
                <div class="head">
                  <!-- <b>DOB :</b> {{ patient?.date_of_birth | date }} -->
                  <b>Age :</b> {{ patient?.age }}
                </div>
                <div class="head">
                  <b>Address :</b> {{ patient?.local_address1 }}
                </div>
                <div class="head">
                  <b>Reg. No. :</b> {{ templates?.data?.reg_code }}
                </div>

                <!-- <div class="name">
                  <b>Bill No. :</b> {{ templates.data?.bill_id }}
                </div>
                <div class="name">
                  <b>Result No. :</b> {{ templates.data?.result_id }}
                </div> -->
              </div>
              <div class="main" style="z-index: 2">
                <!-- <div class="name">
                  <b>Referred Dr :</b> {{ refDr?.Acount_Name }}
                </div> -->
                <!-- <div class="name">
                  <b>Lab. No. :</b> EDLS/LAB/{{ year }}/{{ record?.lab_regno }}
                </div> -->
                <div class="name">
                  <b>Reporting Date:</b> {{ record?.result_date | date }}
                  <span>{{ record?.result_time }}</span>
                  <!-- <span style="color: red">{{ record?.finalized_time }}</span> -->
                </div>
                <!-- <div class="name">
                  <b>Sample Time:</b> {{ record?.sample_collect_date | date }}
                  <span>{{
                    record?.sample_collect_date | date : "h:mm a"
                  }}</span>
                </div> -->
                <div class="name">
                  <b>Printed Time:</b> {{ today | date }}
                  <span>{{ time }}</span>
                </div>
              </div>
            </div>

            <div
              class="return"
              style="width: 800px; margin-bottom: 20px; z-index: 2"
              #name
            ></div>

            <div
              class="sign"
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                z-index: 2;
              "
            >
              <div
                style="
                  z-index: 2;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                "
              >
                <img
                  style="width: 250px; height: 70px; margin-left: -70px"
                  *ngIf="templates.data.initator.signature"
                  [src]="templates.data.initator.signature"
                  alt=""
                />
                <div>...........................</div>
                <div>{{ templates.data?.initator?.name }}</div>
                <div>{{ templates.data?.initator?.designation }}</div>
                <div>{{ templates.data?.initator?.qualification }}</div>
              </div>
              <img
                *ngIf="isChecked"
                style="width: 170px; height: 170px"
                [src]="templates.data.barcode"
                alt=""
              />
              <div
                *ngIf="!obs"
                style="
                  z-index: 2;
                  margin-left: 150px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                "
              >
                <img
                  style="width: 250px; height: 70px; margin-left: -70px"
                  *ngIf="templates.data.finalizer.signature"
                  [src]="templates.data.finalizer.signature"
                  alt=""
                />
                <div>...........................</div>
                <div>{{ templates.data?.finalizer?.name }}</div>
                <div>{{ templates.data?.finalizer?.designation }}</div>
                <div>{{ templates.data?.finalizer?.qualification }}</div>
              </div>
            </div>
          </div>

          <div style="height: 500px; width: 100%"></div>
        </div>
      </app-template>
    </div>
  </div>
</div>
